<template>
    <button :class="['cz__swatch-button', 'cz__option-button', { 'cz__option--selected': selected }]" :style="{ 'background-color': hexValue(option.custom.hex) }" @click="optionSelected" :title="option.name || option.code">
    </button>
</template>

<style lang="less">
    .cz__swatch-button.cz__option-button {
        width: 32px;
        height: 32px;

        border-radius: 32px;

        border: 1px solid transparent;

        cursor: pointer;

        &.cz__option--selected {
            position: relative;

            &:after {
                content: '';

                position: absolute;

                left: -1px;
                bottom: -8px;

                width: ~"calc(100% + 2px)";
                height: 3px;

                background: #000;
            }
        }

        &:focus {
            outline: none;
            border: 1px solid #000;
        }
    }
</style>

<script>
    export default {
        props: {
            controller: Object,
            blueprint: Object,
            option: Object,
            selected: Boolean,
            components: Array,
        },
        methods: {
            hexValue(v) {
                return v[0] === '#' ? v : ('#' + v);
            },

            optionSelected() {
                this.$emit('select', this.option);
            },
        },
    };
</script>